@if (!hideTopNavMenu && isLoggedIn) {
<mat-toolbar>
  <mat-toolbar-row>
    <span class="page-title"></span>
    <span class="spacer"></span>
    <button class="nova__button--icon" id="user-delegations-button" data-qa-id="top-nav-user-delegations-button"
      aria-label="User delegations" (click)="openUserDelegationsDialog()"
      [class.active]="isUserDelegationsDialogActive">
      <mat-icon svgIcon="delegate"></mat-icon>
    </button>
    <button mat-flat-button [matMenuTriggerFor]="userMenu" aria-label="User menu" id="user-menu-button"
      data-qa-id="top-nav-user-menu-button">
      {{userInitials}}
    </button>
    <mat-menu #userMenu="matMenu">
      <div class="user-menu-content">
        <div class="user-welcome-msg">Hi {{userDisplayName}}!</div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openModule(modules.USER_DELEGATES, 'delegations')">
          <mat-icon svgIcon="delegate"></mat-icon>
          <span>Delegates List</span>
        </button>
        <button mat-menu-item (click)="openModule(modules.NOVA_IDEAS, 'https://nova.ideas.aha.io/')">
          <mat-icon>emoji_objects</mat-icon>
          <span>Submit An Idea</span>
        </button>
        <button mat-menu-item (click)="openModule(modules.CORPORATE, '/corporate-directory')">
          <mat-icon>contact_phone</mat-icon>
          <span>Corporate Directory</span>
        </button>
        <button mat-menu-item
          (click)="openModule(modules.HELP_DIRECTORY, 'https://thepulse.ayahealthcare.com/help-directory/')">
          <mat-icon>help</mat-icon>
          <span>Help Directory</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="signOut()" data-qa-id="sign-out-button">
          <mat-icon>logout</mat-icon>
          <span>Sign Out</span>
        </button>
      </div>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
}